import { ActionType, getType } from 'typesafe-actions'
import * as actions from './actions'

import N from '../../utils/assert-never'

import { initial as initialState, Type as State } from './state'

export type Action = ActionType<typeof actions>

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  switch (action.type) {
    case getType(actions.getProjects):
      return {
        ...state,
        loading: true,
        result: initialState.result,
      }
    case getType(actions.getProjectsCompleted):
      if (action.payload.type === 'success') {
        return {
          ...state,
          result: action.payload.payload,

          loading: false,
        }
      } else {
        return state
      }

    case getType(actions.filterUpdated):
      return {
        ...state,
        filter: 'payload' in action ? action.payload : state.filter,
        tablePagination: { ...state.tablePagination, pageNo: 1 },
      }

    case getType(actions.saveProject):
      if ('payload' in action) {
        return { ...state, saving: true }
      } else {
        return state
      }

    case getType(actions.saveProjectCompleted):
      if ('payload' in action) {
        return { ...state, saving: false } as State
      } else {
        return state
      }

    case getType(actions.doProjectAction):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }
    case getType(actions.doProjectActionComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          const newProject = action.payload.payload

          return {
            ...state,
            loading: false,
            error: null,
            result: {
              ...state.result,
              projects: state.result.projects.map((project) => {
                if (project.id === newProject.id) {
                  return newProject
                } else {
                  return project
                }
              }),
            },
          } as State
        } else {
          return {
            ...state,
            loading: false,
            error: action.payload.payload.message,
          } as State
        }
      } else {
        return state
      }

    case getType(actions.onCurrentPageChange):
      if ('payload' in action) {
        return {
          ...state,
          tablePagination: {
            ...state.tablePagination,
            pageNo: action.payload,
          },
        }
      } else {
        return state
      }

    case getType(actions.onPageSizeChange):
      if ('payload' in action) {
        return {
          ...state,
          tablePagination: {
            ...state.tablePagination,
            resultsPerPage: action.payload,
          },
        }
      } else {
        return state
      }
    case getType(actions.onSortingChange):
      if ('payload' in action) {
        return {
          ...state,
          tablePagination: {
            ...state.tablePagination,
            ordering: action.payload,
          },
        }
      } else {
        return state
      }
  }

  return N(action, state)
}
